module.exports = __webpack_public_path__ + "img/fgr-1.14295033.svg";